// extracted by mini-css-extract-plugin
export default {"dom-slide-empty":"styles_dom-slide-empty__KJdFs"};